
import { BoxMaintenanceCreatePage } from "./create.box";
import { CloudMaintenanceCreatePage } from "./create.cloud";
import { DemoMaintenanceCreatePage } from "./create.demo";

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class MaintenanceEdit extends mixin(environment.nexus, {
  box: BoxMaintenanceCreatePage,
  cloud: CloudMaintenanceCreatePage,
  demo: DemoMaintenanceCreatePage,
}) {
  [key: string]: any;
}
